(function () {
    'use strict';

    angular
        .module('app')
        .controller('PermissionController', PermissionController);

    // Define controller dependencies.
    PermissionController.$inject = ['$rootScope', '$scope', 'CRUDFactory', 'DataListFactory'];

    /**
     * Controller for 'main' view of 'master.permission' state.
     *
     * @param $rootScope
     * @param $scope
     * @param CRUDFactory
     * @param DataListFactory
     * @constructor
     */
    function PermissionController($rootScope, $scope, CRUDFactory, DataListFactory) {
        /**
         * --------------------------------------------
         * Private variables.
         * --------------------------------------------
         */

        /**
         * This controller.
         */
        var vm = this;

        /**
         * --------------------------------------------
         * Bindable members.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Private methods.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Bindable member implementations.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Controller activation.
         * --------------------------------------------
         */

        /**
         * Activate controller.
         */
        function activate() {
            var resource = 'permission';

            $rootScope.global.pageTitle = 'Master Permission';

            $scope.shared.printDisabled = true;
            $scope.shared.editor.template = 'components/master/permission/permission-editor.view.html';
            $scope.shared.editor.focusElement = '#permission--application-code';
            $scope.shared.reader.template = 'components/master/permission/permission-reader.view.html';

            DataListFactory.reset();
            DataListFactory.resource = resource;
            DataListFactory.gridOptions.columnDefs = angular.copy($rootScope.global.columnDefs.common);
            DataListFactory.gridOptions.columnDefs.splice.apply(DataListFactory.gridOptions.columnDefs,
                [1, 0].concat($rootScope.global.columnDefs[resource]));

            DataListFactory.advancedSearchFactory.reset();
            DataListFactory.advancedSearchFactory.resource = resource;
            angular.forEach($rootScope.global.searchResourceFields[resource], function (relation) {
                var resourceField = {
                    relation: relation.relation,
                    fields  : angular.copy($rootScope.global.resourceFields.common)
                }
                resourceField.fields.splice.apply(resourceField.fields,
                    [1, 0].concat($rootScope.global.resourceFields[relation.resource]));
                DataListFactory.advancedSearchFactory.resourceFields.push(resourceField);
            });

            CRUDFactory.resource = resource;
        }

        activate();
    }
})();
